import Vue from 'vue'

Vue.prototype.$scrollToFirstErrorInput = function () {
  if (this.$el.querySelector('[data-vv-name="' + this.$validator.errors.items[0].field + '"]')) {
    this.$el.querySelector('[data-vv-name="' + 
      this.$validator.errors.items[0].field + '"]').scrollIntoView()
  }  
} 

Vue.prototype.$logout = function () {
  return this.$store.dispatch('logout')
}

Vue.prototype.$manualLogout = function () {
  return this.$store.dispatch('manualLogout')
}

Vue.prototype.$refreshAccess = function () {
  return this.$store.dispatch('refreshAccess')
}

Vue.prototype.$snack = function (params) {
  return this.$store.commit('app/snack', params, { root: true })
}

Vue.prototype.$hasPermissionTo = function (permissions) {
  let intersections = this.$store.state.permissions.filter(permission => permissions.includes(permission.name))

  return intersections.length === permissions.length
}

Vue.prototype.$resetData = function () {
  Object.assign(this.$data, this.$options.data.apply(this))
}

// Multipart sends everything as strings: null becomes '' (backend converts it back to null) and booleans become 1/0
Vue.prototype.$toFormData = function (data) {
  let formData = new FormData()

  Object.keys(data).forEach(key => {
    let value = data[key]

    if (value === null || value === undefined) value = ''
    if (typeof value === 'boolean') value = value ? 1 : 0

    formData.append(key, value)
  })

  return formData
}

Vue.prototype.$dialog = function (params) {
  return this.$store.commit('app/dialog', params, { root: true })
}

Vue.prototype.$filenameFromDisposition = function (disposition) {
  if (!disposition) return null

  let encoded = disposition.match(/filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/)
  if (encoded) return decodeURIComponent(encoded[1].trim().replace(/"/g, ''))

  let plain = disposition.match(/filename\s*=\s*"?([^";]+)"?/)
  return plain ? plain[1].trim() : null
}
